/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for ContactResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetContactByIdResponse, CustomerState, GetContactsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class ContactResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getContactById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetContactByIdResponse, unknown> & { defaultValue: NoInfer<GetContactByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetContactByIdResponse>;
    getContactById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetContactByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetContactByIdResponse | undefined>;
    getContactById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetContactByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetContactByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Contact/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getContacts(searchTerm: Signal<string | null | undefined> | string | null | undefined, states: Signal<(Array<CustomerState> | null) | undefined> | (Array<CustomerState> | null) | undefined, resourceOptions: HttpResourceOptions<GetContactsResponse, unknown> & { defaultValue: NoInfer<GetContactsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetContactsResponse>;
    getContacts(searchTerm?: Signal<string | null | undefined> | string | null, states?: Signal<(Array<CustomerState> | null) | undefined> | (Array<CustomerState> | null), resourceOptions?: HttpResourceOptions<GetContactsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetContactsResponse | undefined>;
    getContacts(searchTerm?: Signal<string | null | undefined> | string | null, states?: Signal<(Array<CustomerState> | null) | undefined> | (Array<CustomerState> | null), resourceOptions?: HttpResourceOptions<GetContactsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetContactsResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            const statesValue = typeof states === 'function' ? states() : states;
            if (statesValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, statesValue, 'states');
            }
            return {
                url: `${this.basePath}/Contact`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
